module.exports = __webpack_public_path__ + "img/3.9cb47172.jpg";